import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_US',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'edd2ee45-1375-4238-944f-52763a385135',
  ''
);
